// Updated src/hooks/useAuth.js - Handle async initialization
import { useEffect } from 'react'
import { useAuthStore } from '@/stores/authStore'

export const useAuth = () => {
    const {
        user,
        isAuthenticated,
        isLoading,
        error,
        pending2FA,
        login,
        verify2FA,
        cancel2FA,
        register,
        logout,
        initialize,
        clearError,
        refreshProfile
    } = useAuthStore()

    useEffect(() => {
        // Initialize auth and socket connection
        initialize().catch(console.error)
    }, [initialize])

    return {
        user,
        isAuthenticated,
        isLoading,
        error,
        pending2FA,
        login,
        verify2FA,
        cancel2FA,
        register,
        logout,
        initialize,
        clearError,
        refreshProfile
    }
}